import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CombinationPermit from '../../menforms/form/CombinationFamilyPermit'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Combination 1–2 Family Permit || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="Combination 1–2 Family Permit"
            subtitledown="Combination 1–2 Family Permit"
           />
            <CombinationPermit/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main